import { render, staticRenderFns } from "./modelInfo.vue?vue&type=template&id=32c3ce00&scoped=true"
import script from "./modelInfo.vue?vue&type=script&lang=js"
export * from "./modelInfo.vue?vue&type=script&lang=js"
import style0 from "./modelInfo.vue?vue&type=style&index=0&id=32c3ce00&prod&lang=scss&scoped=true"
import style1 from "./modelInfo.vue?vue&type=style&index=1&id=32c3ce00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c3ce00",
  null
  
)

export default component.exports